import { z } from 'zod';

const DEFAULT_APP_NAME = 'Super Admin';

const envSchema = z.object({
  VITE_API_URL: z.string().min(1),
  VITE_APP_NAME: z.string().min(1).default(DEFAULT_APP_NAME),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']),
});

const parsed = envSchema.safeParse({
  VITE_API_URL: import.meta.env['VITE_API_URL'],
  VITE_APP_NAME: import.meta.env['VITE_APP_NAME'] || undefined,
  VITE_APP_ENV: import.meta.env['VITE_APP_ENV'],
});

if (!parsed.success) {
  throw new Error(
    `[env] Invalid environment variables:\n${parsed.error.issues.map((i) => `  ${i.path.join('.')}: ${i.message}`).join('\n')}\n` +
      `Copy apps/web/.env.example to apps/web/.env and fill in the values.`,
  );
}

export const env = parsed.data;
